var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",staticStyle:{"width":"100%"},attrs:{"fluid":""}},[_c('LoadFileDetail',{attrs:{"detail":_vm.detail,"completed":_vm.completed},on:{"saveFile":_vm.saveFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }